import { DatePicker, Input, Select } from "antd";
import { TableProps } from "antd/es/table";
import dayjs from "dayjs";
import DateIcon from "../../../assets/icons/DateIcon";
import DotIcon from "../../../assets/icons/DotIcon";
import FilterIcon from "../../../assets/icons/FilterIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import SortIcon from "../../../assets/icons/SortIcon";
import CustomTable from "../../../components/ui/CustomTable";
import { dateFormat } from "../../../constants/constants";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { formatDate } from "../../../lib/time";
import { countParPageSerialNumber } from "../../../utils/number";
import { selectSearchOption, selectStringOption } from "../../../utils/utils";

export default function Payment() {
  const { page, limit, handlePagination, handleLimit } = useTable();

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Client ID",
      dataIndex: "clientId",
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
    },
    {
      title: "Email Address",
      dataIndex: "email",
    },

    {
      title: "User",
      dataIndex: "userid",
      sorter: (a, b) => a.userid.localeCompare(b.userid),
      sortIcon: () => <SortIcon />,
    },
    {
      title: "Package",
      dataIndex: "pack",
      sorter: (a, b) => a.pack.localeCompare(b.pack),
      sortIcon: () => <SortIcon />,
      render: (text) => (
        <p className="flex items-center">
          <DotIcon />
          <span className="ml-[6px]"> {text}</span>
        </p>
      ),
    },
    {
      title: "Amount (BDT)",
      dataIndex: "payment",
      sorter: (a, b) => a.pkg.localeCompare(b.pkg),
      sortIcon: () => <SortIcon />,
    },
    {
      title: "Pkg Expire",
      dataIndex: "pkg",
      sorter: (a, b) => a.pkg.localeCompare(b.pkg),
      sortIcon: () => <SortIcon />,
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      render: (value: keyof typeof PaymentStatus) => (
        <span className={PaymentStatus[value]}>{value}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (value: keyof typeof Status) => (
        <span className={Status[value]}>{value}</span>
      ),
    },
  ];

  return (
    <SidebarLayout title="Payment Management">
      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={120} // Update total as per the data
        dataSource={data}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search by name, id"
              style={{ width: 220 }}
            />
            <Select
              allowClear
              showSearch
              placeholder="Filter"
              filterOption={selectSearchOption}
              // options={selectStringOption([
              //   "IT",
              //   "Design",
              //   "Development",
              //   "Mobile App",
              // ])}
              className="min-w-[130px]"
              suffixIcon={<FilterIcon />}
              rootClassName="icon-gray"
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              filterOption={selectSearchOption}
              options={selectStringOption(["Active", "Inactive", "New"])}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            />

            <DatePicker
              defaultValue={dayjs(formatDate(), dateFormat)}
              format={dateFormat}
              style={{ width: 135 }}
              suffixIcon={<DateIcon />}
            />

            <Select
              allowClear
              showSearch
              placeholder="digiGO"
              filterOption={selectSearchOption}
              // options={selectStringOption(["Active", "Inactive"])}
              className="min-w-[90px] "
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            />
          </>
        }
      />
    </SidebarLayout>
  );
}

interface DataType {
  clientId: string;
  companyName: string;
  email: string;
  userid: string;
  pack: string;
  pkg: string;
  payment: string;
  paymentMethod: string;
  status: string;
  id: string;
}

const data: DataType[] = [
  {
    clientId: "000193",
    companyName: "Jacob Jones",
    email: "name@email.com",
    userid: "123",
    pack: "Package",
    pkg: "10 Jan, 2026",
    payment: "1200",
    paymentMethod: "Free",
    status: "New",
    id: "1",
  },
  {
    clientId: "000193",
    companyName: "Jacob Jones",
    email: "name@email.com",
    userid: "123",
    pack: "Package",
    pkg: "10 Jan, 2026",
    payment: "1200",
    paymentMethod: "Auto Pay",
    status: "Inactive",
    id: "2",
  },
  {
    clientId: "000193",
    companyName: "Jacob Jones",
    email: "name@email.com",
    userid: "123",
    pack: "Package",
    pkg: "10 Jan, 2026",
    payment: "1200",
    paymentMethod: "Auto Pay",

    status: "Active",
    id: "3",
  },
  {
    clientId: "000193",
    companyName: "Jacob Jones",
    email: "name@email.com",
    userid: "123",
    pack: "Package",
    pkg: "10 Jan, 2026",
    payment: "1200",
    paymentMethod: "Free",
    status: "Expire",
    id: "4",
  },
];

enum Status {
  Active = "status-success",
  Inactive = "status-info",
  New = "status-dark",
  Expire = "status-danger",
}

enum PaymentStatus {
  Free = "status-success",
  "Auto Pay" = "status-info",
}
